import { render, staticRenderFns } from "./TagCategoryIds.vue?vue&type=template&id=c1ac53e0&"
import script from "./TagCategoryIds.vue?vue&type=script&lang=ts&"
export * from "./TagCategoryIds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports